__turbopack_context__.v({
  "buttonWrapper": "items-form-block1440px-module-scss-module__muPiWG__buttonWrapper",
  "error": "items-form-block1440px-module-scss-module__muPiWG__error",
  "errorText": "items-form-block1440px-module-scss-module__muPiWG__errorText",
  "form": "items-form-block1440px-module-scss-module__muPiWG__form",
  "formblock": "items-form-block1440px-module-scss-module__muPiWG__formblock",
  "icon": "items-form-block1440px-module-scss-module__muPiWG__icon",
  "icon5": "items-form-block1440px-module-scss-module__muPiWG__icon5",
  "item1": "items-form-block1440px-module-scss-module__muPiWG__item1",
  "item11": "items-form-block1440px-module-scss-module__muPiWG__item11",
  "item2": "items-form-block1440px-module-scss-module__muPiWG__item2",
  "items": "items-form-block1440px-module-scss-module__muPiWG__items",
  "label": "items-form-block1440px-module-scss-module__muPiWG__label",
  "leftcol": "items-form-block1440px-module-scss-module__muPiWG__leftcol",
  "lookingForA": "items-form-block1440px-module-scss-module__muPiWG__lookingForA",
  "lookingformblock1440px": "items-form-block1440px-module-scss-module__muPiWG__lookingformblock1440px",
  "rightcol": "items-form-block1440px-module-scss-module__muPiWG__rightcol",
  "row": "items-form-block1440px-module-scss-module__muPiWG__row",
  "tellUsWhat": "items-form-block1440px-module-scss-module__muPiWG__tellUsWhat",
  "tellUsWhatContainer": "items-form-block1440px-module-scss-module__muPiWG__tellUsWhatContainer",
  "text": "items-form-block1440px-module-scss-module__muPiWG__text",
  "text1": "items-form-block1440px-module-scss-module__muPiWG__text1",
  "text6": "items-form-block1440px-module-scss-module__muPiWG__text6",
  "textField": "items-form-block1440px-module-scss-module__muPiWG__textField",
  "wrapper": "items-form-block1440px-module-scss-module__muPiWG__wrapper",
});
